import { Component } from 'react';

import mgr from '../../auth-config';

/**
 * Sign in callback
 */
class Callback extends Component {

    /**
     * Executes on component did mount
     */
    componentDidMount() {
        mgr.signinRedirectCallback().then(() => {
            // redirect to route
            window.location = window.location.origin;
        }).catch(function (e) {
            console.error(`Sign in error occoured : ${e}`);
        });
    }

    /**
     * This component does not need to be rendered. It should handle sign in callack from Open ID Connect
     */
    render() {
        return '';
    }
}

export default Callback;


// WEBPACK FOOTER //
// ./src/components/callback/callback.js